import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-weituodan",
  "use": "icon-weituodan-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-weituodan\"><path d=\"M10.94 13.161c-.875 0-2.315.25-2.502.813h-.813c-.25-.563-1.627-.813-2.503-.813H.494V1.026h5.004c1.063 0 2.001.563 2.502 1.376a2.947 2.947 0 012.502-1.376h5.004v12.136H10.94zM7.625 3.528c0-1-1.064-1.689-2.064-1.689H1.37v10.446h3.752c.814 0 2.127 0 2.503.626V3.528zm7.068-1.689h-4.19c-1.064 0-2.065.688-2.065 1.689v9.32c.376-.625 1.689-.625 2.503-.625h3.753V1.839z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/weituodan.svg
// module id = 520
// module chunks = 4